<template>
  <transition
    name="unpin-slide"
    @after-leave="afterLeave"
  >
    <div v-if="!isLeaving" class="info-card" :class="{ expanded: expanded.form, collapsed: !expanded.form }">
        <div class="info-card-content">
          <div v-if="!expanded.form">
            <div class="info-row">
              <div class="icon-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M4.66667 12.1667C4.90278 12.1667 5.10069 12.0868 5.26042 11.9271C5.42014 11.7674 5.5 11.5694 5.5 11.3333C5.5 11.0972 5.42014 10.8993 5.26042 10.7396C5.10069 10.5799 4.90278 10.5 4.66667 10.5C4.43056 10.5 4.23264 10.5799 4.07292 10.7396C3.91319 10.8993 3.83333 11.0972 3.83333 11.3333C3.83333 11.5694 3.91319 11.7674 4.07292 11.9271C4.23264 12.0868 4.43056 12.1667 4.66667 12.1667ZM4.66667 8.83333C4.90278 8.83333 5.10069 8.75347 5.26042 8.59375C5.42014 8.43403 5.5 8.23611 5.5 8C5.5 7.76389 5.42014 7.56597 5.26042 7.40625C5.10069 7.24653 4.90278 7.16667 4.66667 7.16667C4.43056 7.16667 4.23264 7.24653 4.07292 7.40625C3.91319 7.56597 3.83333 7.76389 3.83333 8C3.83333 8.23611 3.91319 8.43403 4.07292 8.59375C4.23264 8.75347 4.43056 8.83333 4.66667 8.83333ZM4.66667 5.5C4.90278 5.5 5.10069 5.42014 5.26042 5.26042C5.42014 5.10069 5.5 4.90278 5.5 4.66667C5.5 4.43056 5.42014 4.23264 5.26042 4.07292C5.10069 3.91319 4.90278 3.83333 4.66667 3.83333C4.43056 3.83333 4.23264 3.91319 4.07292 4.07292C3.91319 4.23264 3.83333 4.43056 3.83333 4.66667C3.83333 4.90278 3.91319 5.10069 4.07292 5.26042C4.23264 5.42014 4.43056 5.5 4.66667 5.5ZM7.16667 12.1667H12.1667V10.5H7.16667V12.1667ZM7.16667 8.83333H12.1667V7.16667H7.16667V8.83333ZM7.16667 5.5H12.1667V3.83333H7.16667V5.5ZM2.16667 15.5C1.70833 15.5 1.31597 15.3368 0.989583 15.0104C0.663194 14.684 0.5 14.2917 0.5 13.8333V2.16667C0.5 1.70833 0.663194 1.31597 0.989583 0.989583C1.31597 0.663194 1.70833 0.5 2.16667 0.5H13.8333C14.2917 0.5 14.684 0.663194 15.0104 0.989583C15.3368 1.31597 15.5 1.70833 15.5 2.16667V13.8333C15.5 14.2917 15.3368 14.684 15.0104 15.0104C14.684 15.3368 14.2917 15.5 13.8333 15.5H2.16667ZM2.16667 13.8333H13.8333V2.16667H2.16667V13.8333Z" fill="#25B8C2"/>
                </svg>
              </div>
              <p class="info-text-title">Form:</p>
            </div>
          </div>
            <div v-else class="info-card-content-col-group">
                <div class="info-row">
                    <div class="icon-container">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M4.66667 12.1667C4.90278 12.1667 5.10069 12.0868 5.26042 11.9271C5.42014 11.7674 5.5 11.5694 5.5 11.3333C5.5 11.0972 5.42014 10.8993 5.26042 10.7396C5.10069 10.5799 4.90278 10.5 4.66667 10.5C4.43056 10.5 4.23264 10.5799 4.07292 10.7396C3.91319 10.8993 3.83333 11.0972 3.83333 11.3333C3.83333 11.5694 3.91319 11.7674 4.07292 11.9271C4.23264 12.0868 4.43056 12.1667 4.66667 12.1667ZM4.66667 8.83333C4.90278 8.83333 5.10069 8.75347 5.26042 8.59375C5.42014 8.43403 5.5 8.23611 5.5 8C5.5 7.76389 5.42014 7.56597 5.26042 7.40625C5.10069 7.24653 4.90278 7.16667 4.66667 7.16667C4.43056 7.16667 4.23264 7.24653 4.07292 7.40625C3.91319 7.56597 3.83333 7.76389 3.83333 8C3.83333 8.23611 3.91319 8.43403 4.07292 8.59375C4.23264 8.75347 4.43056 8.83333 4.66667 8.83333ZM4.66667 5.5C4.90278 5.5 5.10069 5.42014 5.26042 5.26042C5.42014 5.10069 5.5 4.90278 5.5 4.66667C5.5 4.43056 5.42014 4.23264 5.26042 4.07292C5.10069 3.91319 4.90278 3.83333 4.66667 3.83333C4.43056 3.83333 4.23264 3.91319 4.07292 4.07292C3.91319 4.23264 3.83333 4.43056 3.83333 4.66667C3.83333 4.90278 3.91319 5.10069 4.07292 5.26042C4.23264 5.42014 4.43056 5.5 4.66667 5.5ZM7.16667 12.1667H12.1667V10.5H7.16667V12.1667ZM7.16667 8.83333H12.1667V7.16667H7.16667V8.83333ZM7.16667 5.5H12.1667V3.83333H7.16667V5.5ZM2.16667 15.5C1.70833 15.5 1.31597 15.3368 0.989583 15.0104C0.663194 14.684 0.5 14.2917 0.5 13.8333V2.16667C0.5 1.70833 0.663194 1.31597 0.989583 0.989583C1.31597 0.663194 1.70833 0.5 2.16667 0.5H13.8333C14.2917 0.5 14.684 0.663194 15.0104 0.989583C15.3368 1.31597 15.5 1.70833 15.5 2.16667V13.8333C15.5 14.2917 15.3368 14.684 15.0104 15.0104C14.684 15.3368 14.2917 15.5 13.8333 15.5H2.16667ZM2.16667 13.8333H13.8333V2.16667H2.16667V13.8333Z" fill="#25B8C2"/>
                      </svg>
                    </div>
                </div>
                <div>
                  <div v-if="formData.primaryForm">
                    <p class="info-text-title">Form:</p>
                    <p class="info-text mb-2 mt-1">{{ formData.primaryForm.title }}</p>
                    <p class="info-text-title">Form Status:</p>
                    <p class="info-text">{{ formData.primaryForm.status }}</p>
                  </div>
                  <div v-else>
                    <p class="info-text mb-2 mt-1">No forms assigned</p>
                    <p class="info-text-title">Form Status:</p>
                    <p class="info-text">N/A</p>
                  </div>
                </div>
            </div>
            <div v-if="expanded.form" class="action-icons">
              <div v-if="!isCardPinned" class="action-icon" @click.stop="handlePinCard">
                <img src="@/assets/cardActions/pin.svg" alt="Unpin" />
              </div>
              <div v-if="isCardPinned" class="action-icon" @click.stop="startUnpin">
                <img src="@/assets/cardActions/unpin.svg" alt="Pin" />
              </div>
             <div v-if="showFooter" class="action-icon" @click.stop="toggleCard('form')">
              <img src="@/assets/cardActions/collapse.svg" alt="Expand" />
             </div>
            </div>
            <div v-else class="flex flex-row items-center gap-2">
              <div class="action-icon" @click.stop="toggleCard('form')">
                <img src="@/assets/cardActions/expand.svg" alt="Collapse" />
              </div>
              <div class="drag-handle action-icon">
                <img src="@/assets/cardActions/move.svg" alt="move" />
              </div>
            </div>
          </div>
          <div class="card-expand" :class="{ 'justify-end': !showFooter, 'justify-between': showFooter }">
            <FoldableButton v-if="showFooter" customized_class="drag-handle" text="Move">
              <template #prefix>
                <img src="@/assets/cardActions/move.svg" alt="Move" />
              </template>
            </FoldableButton>
            <div class="flex flex-row gap-1 justify-end">
              <FoldableButton text="View">
                <template #prefix>
                  <img src="@/assets/cardActions/view.svg" alt="View" />
                </template>
              </FoldableButton>
              <FoldableButton text="Resend">
                <template #prefix>
                  <img src="@/assets/cardActions/resend.svg" alt="Resend" />
                </template>
              </FoldableButton>
            </div>
        </div>
    </div>
  </transition>

    
</template>
<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useCardActions } from '@/composables/useCardActions';
import { useMyPatientsStore } from '@/store/helpers';

// Define props
const props = defineProps({
  patient: {
    type: String,
    default: ''
  },
  cardData: {
    type: Object,
    default: () => ({})
  },
  showFooter: {
    type: Boolean,
    default: true
  },
  context: {
    type: String,
    default: 'pegboard'
  }
})

// Define emits
const emit = defineEmits(['pin-card', 'unpin-card']);

const { isCardPinned, handlePinCard, handleUnpinCard } = useCardActions(props, emit);

const { patientInfoStore } = useMyPatientsStore();


const isLeaving = ref(false);


const startUnpin = () => {
  if(props.showFooter){
    isLeaving.value = true; // triggers the leave animation
  } else {
    handleUnpinCard()
  }
};


// This is called after the leave animation finishes
const afterLeave = () => {
  emit('unpin-card', props.cardData); // parent removes the card
};

const expanded = ref({
      form: true,
    })

const toggleCard = (cardType) => {
      expanded.value[cardType] = !expanded.value[cardType]
    }

import { getCurrentPatientId } from '@/utils/patientUtils';

// Get form data from store
const formData = computed(() => {
  return patientInfoStore.getters.getFormCardData(props.patient) || {
    totalForms: 0,
    allForms: [],
    primaryForm: null
  }
})






</script>


<style scoped>
.pin-toggle {
  position: relative;
  cursor: pointer;
}

.pin-toggle .icon {
  position: absolute;
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.pin-toggle .unpin {
  opacity: 0;
  transform: scale(0.8);
}

/* Hover effect */
.pin-toggle:hover .pin {
  opacity: 0;
  transform: scale(1);
}

.pin-toggle:hover .unpin {
  opacity: 1;
  transform: scale(1);
}


.unpin-slide-leave-active {
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), 
              opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.unpin-slide-leave-to {
  transform: translateX(-100%) scale(0.95);
  opacity: 0;
}

.peg-board-title {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 22px;
  color: #ffffff;
  text-align: center;
  margin-bottom: 16px;
}

.peg-board-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow-y: auto;
  padding: 0 8px;
}

.info-card {
  background-color: white;
  border-radius: 5px;
  padding: 12px 16px;
  box-shadow: 0px 1px 25px 0px rgba(74, 74, 74, 0.15);
}

.info-card-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}

.info-card-content-col-group {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
}

.info-row-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-grow: 1;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.icon-container {
  background-color: #f2f2f2;
  border-radius: 4px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-style {
  width: 20px;
  height: 20px;
}

.info-text {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0.25px;
  line-height: 20px;
}

.action-icons {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.action-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.appointment-date {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 50px;
  height: 64px;
  border-radius: 5px;
  background-color: #ffffff;
  box-shadow: 0px 1px 15px 0px rgba(74, 74, 74, 0.1);
  overflow: hidden;
}

.month {
  background-color: #004879;
  color: white;
  width: 100%;
  text-align: center;
  padding: 2px 0;
  font-size: 14px;
}

.day {
  color: rgba(0, 0, 0, 0.65);
  text-align: center;
  font-family: Lato;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 120% */
  text-transform: capitalize;
  height: 24px;
}

.weekday {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 1;
  padding-bottom: 3px;
}

.appointment-details {
    flex-grow: 1;
}

.detail-title {
    font-size: 12px;
    color: #666;
}
.detail-text {
    font-size: 14px;
    color: #333;
    margin-bottom: 4px;
}
.action-icons-appointment {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding-top: 20px;
}
.info-text-title {
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    color: #666;
}
.info-text-large {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    color: #333;
    font-weight: 500;
}

/* Badge for billing preference */
.badge {
  color: #25B8C2;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px; /* 120% */
  letter-spacing: 0.25px;
  display: flex;
  padding: 4px 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
}

.badge-default {
  border-radius: 20px;
  background: #EBFFF8;
  width: 68px;
}


/* Expanded card footer visibility with hover expand animation */
.card-expand {
  display: flex;
  align-items: center;
  gap: 16px;
  /* animation base state */
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  padding-top: 0;
  margin-top: 0;
  border-top: 1px dashed var(--DividerGray, #C4C4C4);
  border-top-color: transparent;
  pointer-events: none;
  transition: max-height 300ms linear,
              opacity 300ms linear,
              padding-top 300ms linear,
              margin-top 300ms linear,
              border-top-color 300ms linear;
}

.info-card.expanded:hover .card-expand {
  /* ensure enough room for actions */
  max-height: 80px;
  opacity: 1;
  padding-top: 10px;
  margin-top: 10px;
  border-top-color: var(--DividerGray, #C4C4C4);
  pointer-events: auto;
}


.expand-action {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #1B79A0;
  cursor: pointer;
  padding: 4px 10px;
  border-radius: 5px;
}

.expand-action span {
  color: var(--color-Darkblue-000, #1E4670);
  text-align: center;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}


.action-icon {
  width: 28px;          /* w-7 */
  height: 28px;         /* h-7 */
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;   /* rounded-[5px] */
  padding: 5px;         /* pd-5 (assuming you meant padding) */
  cursor: pointer;
  transition: background-color 0.2s; /* duration-200 transition-colors */
}

.action-icon:hover,
.expand-action:hover {
  background-color: #E5F1FB; /* hover:bg-[#E5F1FB] */
}
</style>
